import styled from "styled-components"

export const StyledOfferSlider = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 0 0 50px;
  cursor: grab;
  overflow: hidden;
  @media (max-width: 600px) {
    padding-left: 30px;
  }
`
